import WebApp from "../components/WebApp";

const GettingStarted = () => {
  return (
    <WebApp>
      <div>Home</div>
    </WebApp>
  );
};


export default GettingStarted;